/* eslint-disable import/no-cycle */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import type { PayloadAction } from '@reduxjs/toolkit';

import authReducer, { logout } from '../redux/auth';
import locationReducer from '../redux/location';
import cartReducer from '../redux/cart';
import checkoutReducer from '../redux/checkout';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const appReducer = combineReducers({
  auth: authReducer,
  checkout: checkoutReducer,
  location: locationReducer,
  cart: cartReducer,
});


const rootReducer = (state: any, action: PayloadAction<any>) => {
  // If a logout action is dispatched, reset the entire state to its initial state
  if (action.type === logout.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export function makeStore() {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
}

export const store = makeStore();
export type IRootState = ReturnType<typeof rootReducer>
export type RootState = ReturnType<typeof store.getState>
export const persistor = persistStore(store);
